export default {
    unknown: {
        title: 'Ooops!',
        text: 'Unexpected error. Please, retry in a few seconds'
    },
    unauthorized: {
        title: 'Ooops!',
        text: 'That code is invalid'
    },
    nickCollision: {
        title: 'Ooops!',
        text: 'That nickname has already chosen for other player'
    },
    noItemsSelected: "You haven't items selected",
    mcUnauthorized: {
        title: 'Ooops!',
        text: 'That user is invalid'
    },
    mcUsernameCollision: {
        title: 'Ooops!',
        text: 'That username has already chosen for other Master of Ceremonies'
    },
    mcGameNotFound: {
        title: 'Ooops!',
        text: 'That code does not exist'
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/error.js